import apiSlice from './ApiSlice';

export const upComeingPaymentsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
     // Get All Up Comeing Payments
    getAllUpComeingInstallments: builder.query({
        providesTags: ["trainer"],
        query: (body) => {
          return {
            url: "/dashboard/upcoming-installments",
            method: "POST",
            body
          };
        },
      }),
  }),
});

export const { useGetAllUpComeingInstallmentsQuery  } = upComeingPaymentsApi;